'use client';

import { useCallback, useEffect } from 'react';

export function ScrollToHash() {
  const scrollToElement = useCallback(() => {
    // Delay the scroll to ensure the DOM is fully loaded
    setTimeout(() => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          const offset = 100; // 100px offset
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      }
    }, 100);
  }, []);

  useEffect(() => {
    // Scroll on initial load
    scrollToElement();

    // Add event listener for hash changes
    window.addEventListener('hashchange', scrollToElement);

    // Clean up the event listener
    return () => {
      window.removeEventListener('hashchange', scrollToElement);
    };
  }, [scrollToElement]);

  return null;
}
